import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react"
import { sanitize } from "../../../../util/sanitize"

type AvatarDescriptionModalProps = {
  isOpen: boolean
  onClose: () => void
  name: string
  description: string
  background: string
  color: string
}

const AvatarDescriptionModal = ({
  isOpen,
  onClose,
  name,
  description,
  background,
  color
}: AvatarDescriptionModalProps) => {
  const sanitizedHtml = sanitize(description)

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"xs"}>
      <ModalOverlay />
      <ModalContent
        bg={background ?? "#1AC541"}
        color={color ?? "#FFFFFF"}
        border={"yellow 1px solid"}
      >
        <ModalHeader>{name}</ModalHeader>

        <ModalCloseButton
          _focus={{
            outline: "none"
          }}
        />

        <ModalBody>
          <Text
            textAlign="justify"
            // we have sanitized incoming string
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          ></Text>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default AvatarDescriptionModal
